import * as React from "react";

const SvgIcnQuestionnaires = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M15 4a1 1 0 011 1v2.212l-1 1.005V5H5v14h10v-2.305l1-1V19a1 1 0 01-1 1H5a1 1 0 01-1-1V5a1 1 0 011-1h10zm-5 9v3H7v-3h3zm8.36-5.37l.091.08 1.27 1.275a1 1 0 01.004 1.407L14.207 16h-2.755l-.034-2.65 5.616-5.639a1 1 0 011.327-.08zm-.617.787l-5.32 5.342.016 1.24h1.349l5.224-5.308-1.27-1.274zM13 7v3H7V7h6z"
        />
    </svg>
);

export default SvgIcnQuestionnaires;
